// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3306":"51e36e84","3815":"d479bd0a","4990":"ee81348f","7086":"3538c4fb","7998":"d479bd0a","8205":"ae63a90f"}[chunkId] + ".chunk.css";
};